<template>
  <div>
    <div v-if="loading" class="mt-5">
      <circle-loader :size="40"></circle-loader>
    </div>
    <div v-if="!loading">
      <div class="home" v-if="!customer">
        <div class="loading mt-5" v-if="!error">
          <circle-loader :size="30"></circle-loader>
        </div>
        <div class="error mt-5" v-if="error">
          Error Loading Customer
          <br />
          <router-link to="/app/">Back to Home</router-link>
        </div>
      </div>
      <div class="home text-left page-wrapper" v-if="customer">
        <h1 class="page-h1">{{ customer.name }}</h1>
        <div class="nav text-center">
          <router-link
            class="nav-link"
            :to="`/app/customers/${customer.id}/`"
            style="margin-left: 2px"
            >Overview</router-link
          >
          <router-link
            class="nav-link"
            :to="`/app/customers/${customer.id}/edit`"
            v-if="userStore.user.type === 'ADMIN'"
            >Edit</router-link
          >
          <router-link
            class="nav-link"
            :to="`/app/customers/${customer.id}/profile`"
            >Profile</router-link
          >
          <router-link
            class="nav-link"
            :to="`/app/customers/${customer.id}/files`"
            >Files</router-link
          >
          <router-link
            class="nav-link"
            :to="`/app/customers/${customer.id}/schedule`"
            >Schedule</router-link
          >
          <span class="nav-link">
            <b-button
              class="mx-1 add-button"
              @click="$bvModal.show('createOrderModal')"
              >+ Order</b-button
            >
            <b-button class="mx-1 add-button" @click="goToNewBuilding()"
              >+ Building</b-button
            >
            <b-button
              class="mx-1 add-button"
              @click="goToNewMaterialsQuote()"
              >+ Materials Quote</b-button
            >
          </span>
        </div>
        <b-modal
          id="createOrderModal"
          title="Create Order"
          size="lg"
          hide-footer
          hide-header
        >
          <create-order-page :customer="customer"></create-order-page>
        </b-modal>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import CircleLoader from '@/components/CircleLoader.vue'
import { userStore } from '@/stores/userStore'
import CreateOrderPage from './CreateOrderPage'

export default {
  name: 'CustomerDetailPage',
  inject: { userStore },
  props: {
    customerData: {
      type: Object,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
  },
  data: function () {
    return {
      customer: null,
      error: null,
      loading: true,
    }
  },
  components: { CircleLoader, CreateOrderPage },
  methods: {
    goToNewBuilding() {
      this.$router.push({
        name: 'PricerPage',
        params: {
          config: {
            customer: {
              name: this.customer.name,
              phone: this.customer.phone,
              email: this.customer.email,
              address: this.customer.address,
            },
          },
        },
      })
    },

    goToNewMaterialsQuote() {
      // Navigate to materials quotes page and trigger the create form with customer data
      this.$router.push({
        name: 'MaterialsQuotesPage',
        params: {
          createWithCustomer: {
            name: this.customer.name,
            phone: this.customer.phone,
            email: this.customer.email,
            company: this.customer.company || '',
            id: this.customer.id || this.customer._id
          }
        }
      })
    },
  },
  mounted() {
    if (this.customerData) {
      this.customer = this.customerData
      this.loading = false
    } else if (this.id) {
      axios
        .get('/services/customers/' + this.id)
        .then(response => {
          this.customer = response.data.customer
          this.loading = false
        })
        .catch(error => {
          this.error = true
        })
    } else {
      this.customer = {}
    }
  },
}
</script>

<style lang="scss" scoped>
a {
  font-weight: bold;
  color: #2c3e50;
  padding-left: 8px;
  padding-right: 8px;
  &.router-link-exact-active {
    color: #42b983;
  }

  &:first-child {
    margin-left: 0px;
  }
}

.nav {
  margin-bottom: 2px;
}

.nav-link {
  &::after {
    content: '|';
    color: #2c3e50;
    margin-left: 16px;
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}

.add-button {
  height: 28px;
  line-height: 28px;
  padding: 0px 6px;
  background-color: #42b983;
  border-color: #4bc08b;
  font-size: 16px;
}
</style>
